var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        label: "Update",
        submitLoading: _vm.submitLoading,
        disabled: _vm.isDisabledSubmit
      },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onSubmit
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "flex flex-col gap-4 px-8 pt-8",
          style: { width: "40rem" }
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-col gap-2" },
            [
              _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "p-1 bg-orange-300",
                      style: { borderRadius: "4px" }
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "h-6 w-6",
                        attrs: { icon: "tooltip" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlTextTitle4", {
                    attrs: { text: "Edit action recommendations" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("BlTextBody2", {
                attrs: {
                  text:
                    "Get recommendation after the session when client passes certain conditions."
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("ActionRecommendationInput", {
            attrs: {
              navigateSuccessMetric: false,
              totalSuccess: _vm.totalSuccessInput,
              consecutiveSuccess: _vm.consecutiveSuccessInput
            },
            on: {
              input: function($event) {
                return _vm.onInputActionRecommendation($event)
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35da4c0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35da4c0c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/modal/EditActionRecommendationsModal.vue
// module id = null
// module chunks = 